const statusLabelText = {
  paddingY: 0.5,
  paddingX: 1,
  fontSize: 14,
};
const tableHeadCell = {
  paddingY: 1.5,
  paddingX: 1,
  fontWeight: '600',
  fontSize: { xs: 10, md: 15 },
};
const tableRowCell = {
  paddingY: 1.5,
  paddingX: 1,
  fontSize: { xs: 12, md: 14 },
};
const tableRowCellStatusText = {
  fontSize: 14,
};
const styles = {
  statusLabelText,
  tableHeadCell,
  tableRowCell,
  tableRowCellStatusText,
};

export { styles };
